import { Module } from '../Module';

// TODO: rename to tbDataGridRow, and refactor the willRowBeDeleted (line-through) into another directive.
Module.instance().directive('tbDataGridEditableRow', () => {
  return {
    restrict: 'E',
    replace: true,
    templateUrl: 'dataGridEditableRow.html',
    scope: {
      cells: '=',
      data: '=',
      columnWidths: '=',
      willRowBeDeleted: '=' // boolean representing if we should apply the line-through visual style
    }
  };
});
